export default __webpack_public_path__ + "187ca2106486e4d3ee773f318a20a2c9.svg";